//types
import { RootState } from "../../../types/store";
//import redux
import { connect } from "react-redux";

// actions
import { getOrdersRequest } from "../../../redux/actions/dashboard/orders.actions";
import { getSellerStatsRequest } from "../../../redux/actions/dashboard/sellerStats.actions";
import { login, logout } from "../../../redux/actions/auth.actions";

import MainComponent from "./Main.component";

const mapStateToProps = function (state: RootState) {
  return {
    auth: state.auth,
    ordersTotal: state.orders.total,
    fetchingOrders: Boolean(state.orders.fetchingOrders > 0),
    sellersTotal: state.sellersStats.total,
  };
};

const mapDispatchToProps = function (dispatch: any) {
  return {
    login: (token: string, refreshToken: string) => dispatch(login(token, refreshToken)),
    logout: () => dispatch(logout()),
    getOrdersRequest: (data: any, params: any, entity: string) =>
      dispatch(getOrdersRequest(data, params, entity)),
    getSellerStatsRequest: (data: any, params: any) =>
      dispatch(getSellerStatsRequest(data, params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainComponent);
